export default class CategoryService {
  static fetchCategories = (actions, apiToken) => actions.getAllResources(apiToken, ['categories'])
}
